import { HttpErrorResponse } from '@angular/common/http';
import { graphQLErrorsOf } from './graphql-support.util';

/**
 * `extensions.reason` the API puts on a call refused because the admin's roles
 * lack the permission. The session is fine — logging out for it would be wrong.
 */
export const MISSING_PERMISSION_REASON = 'missing_permission';

export const MISSING_PERMISSION_MESSAGE =
  "You don't have permission to do this. Ask an admin who manages roles to grant it.";

/** True when the API refused the call for a missing admin permission. */
export function isMissingPermissionError(error: unknown): boolean {
  if (error instanceof HttpErrorResponse && error.error?.reason === MISSING_PERMISSION_REASON) {
    return true;
  }
  return graphQLErrorsOf(error).some(
    (graphQLError) => graphQLError?.extensions?.['reason'] === MISSING_PERMISSION_REASON,
  );
}
